import { render } from "./FormComponent2.vue?vue&type=template&id=26f63e1c"
import script from "./FormComponent2.vue?vue&type=script&lang=js"
export * from "./FormComponent2.vue?vue&type=script&lang=js"

import "./FormComponent2.vue?vue&type=style&index=0&id=26f63e1c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__